import { ChatSticker } from 'types/interfaces/chat/ChatSticker';

import { getLocalStorageItem, setLocalStorageItem } from 'helpers/localStorage';

export const RECENT_ASSETS_LOCAL_STORAGE_KEY = 'recentAssets';
export const RECENT_ASSETS_MAX_COUNT = 20;

export interface RecentAsset {
  sticker: ChatSticker;
  count: number;
}

export const getRecentAssets = (): RecentAsset[] => {
  const recentAssetsLS = getLocalStorageItem(RECENT_ASSETS_LOCAL_STORAGE_KEY);

  try {
    if (recentAssetsLS) {
      return (JSON.parse(recentAssetsLS) as RecentAsset[]).filter(
        ({ sticker }) =>
          !!sticker.id && (!!sticker.big_url || !!sticker.preview_url)
      );
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const updateRecentAssets = (newSticker: ChatSticker) => {
  const recentAssets = getRecentAssets();

  const isNewAssetAlreadyUsed = recentAssets.find(
    (asset) => asset.sticker.id === newSticker.id
  );

  if (isNewAssetAlreadyUsed) {
    const newAssets = recentAssets
      .map((recentAsset) => {
        if (recentAsset.sticker.id === newSticker.id) {
          return { ...recentAsset, count: recentAsset.count + 1 };
        }
        return recentAsset;
      })
      .sort((assetItem1, assetItem2) => assetItem2.count - assetItem1.count);

    setLocalStorageItem(
      RECENT_ASSETS_LOCAL_STORAGE_KEY,
      JSON.stringify(newAssets)
    );

    return newAssets;
  }

  const newAssets: RecentAsset[] = recentAssets.slice(
    0,
    RECENT_ASSETS_MAX_COUNT - 1
  );

  newAssets.push({ sticker: newSticker, count: 1 });

  setLocalStorageItem(
    RECENT_ASSETS_LOCAL_STORAGE_KEY,
    JSON.stringify(newAssets)
  );

  return newAssets;
};
